import { IApplicationDetailsGroup } from 'api/digifi/los/layout/GroupsApi';
import { LayoutConfigurationEntityName } from 'enums/LayoutConfigurationEntityName';
import { LayoutConfigurationReferenceType } from 'product_modules/enums/LayoutConfigurationReferenceType';

import { createLayoutEntitiesSlice } from './createLayoutEntitiesSlice';

const {
  reducer,
  removeLayoutEntities: removeApplicationDetailsGroups,
} = createLayoutEntitiesSlice<
  IApplicationDetailsGroup
>({
  referenceType: LayoutConfigurationReferenceType.ApplicationForm,
  layoutConfigurationEntityName: LayoutConfigurationEntityName.Group,
});

export {
  removeApplicationDetailsGroups,
};

export default reducer;
